export default __webpack_public_path__ + "static/media/rejectedRedIcon.8a5825e8.svg";